module.exports = __webpack_public_path__ + "img/9th_college.d66c737a.webp";